import { getBearerToken } from "../authentication/authContext";
// import { getBearerToken } from "../authentication/authenticator";
import { BASE_URL, FUNCTION_URL } from "../data/constants";
import { appCheck } from "../firebase/firebase";
import { getToken } from "firebase/app-check";

export async function post(day, month, year) {
    return await request('POST',
        FUNCTION_URL,
        { targetUrl: BASE_URL + `firstDays=${day}&firstMonths=${month}&firstYear=${year}&search=true&showChart=false&showChartButton=false` });
}

async function request(method, url, body) {
    const bearerToken = await getBearerToken();

    let options = {
        method: method,
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
        },
    };

    if (body) {
        options.body = JSON.stringify(
            {
                data: body
            }
        )
    }

    if (bearerToken) {
        options.headers["Authorization"] = `Bearer ${bearerToken}`
    }

    const { token } = await getToken(appCheck);

    try {
        const resp = await fetch(url, options);

        // TODO throw error and error handling
        if (!resp.ok) {
            console.log('Error fetching data');
        }

        return resp.json();
    } catch (err) {
        return alert(err.message);
    }

}


